const slugifyKey = (value) =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getImageForKey = (key, width = 640, height = 480) =>
  `https://picsum.photos/seed/${slugifyKey(key)}/${width}/${height}`;

export const getImageForIndex = (index, width = 640, height = 480) =>
  getImageForKey(`vb-service-${index}`, width, height);

